import { useEffect, useRef, useState } from "react";

type countryCodeDropDownAndPhoneFieldProps = {
    phoneNumber: string,
    setPhoneNumber: (e: any) => void,
    countryCode: any,
    setCountryCode: (e: any) => void,
}
export default function CountryCodeDropDownAndPhoneField({phoneNumber, setPhoneNumber, countryCode, setCountryCode} : countryCodeDropDownAndPhoneFieldProps) {
    
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState("");
    const countryOptions = [
        { code: "+47", country: "Norge", flag: "🇳🇴" },
        { code: "+46", country: "Sweden", flag: "🇸🇪" },
        { code: "+45", country: "Denmark", flag: "🇩🇰" },
        { code: "+358", country: "Finland", flag: "🇫🇮" },
        { code: "+44", country: "United Kingdom", flag: "🇬🇧" },
        { code: "+1", country: "United States", flag: "🇺🇸" },
        { code: "+34", country: "Spain", flag: "🇪🇸" },
        { code: "+49", country: "Germany", flag: "🇩🇪" },
    ];
    useEffect(() => {
        // Simulate auto-detection for dummy testing
        const detected = { code: "+47", country: "Norge", flag: "🇳🇴" };
        setCountryCode(detected);
    }, []);

    // Close dropdown on outside click or Esc key
    useEffect(() => {
        function handleClickOutside(event: any) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        }
        function handleEsc(event: any) {
            if (event.key === "Escape") setDropdownOpen(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEsc);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEsc);
        };
    }, []);

    const filteredCountries = countryOptions.filter((option) =>
        option.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
        option.code.includes(searchTerm)
    );

    return (
        <div className="flex items-center gap-2 relative" ref={dropdownRef}>
            <div className="relative">
                <input
                    type="text"
                    placeholder="Type country or code..."
                    value={searchTerm || `${countryCode.flag} ${countryCode.country} ${countryCode.code}`}
                    onFocus={() => setDropdownOpen(true)}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setDropdownOpen(true);
                    }}
                    className="w-32 border focus:border-purple-600 focus:ring-purple-600 rounded-full text-sm px-4 py-2"
                />
                {dropdownOpen && (
                    <div className="absolute top-10 left-0 w-48 bg-white border border-purple-100 rounded-lg shadow-lg max-h-40 overflow-y-auto z-20">
                        {filteredCountries.map((option) => (
                            <div
                                key={option.code}
                                onClick={() => {
                                    setCountryCode(option);
                                    setSearchTerm(`${option.flag} ${option.country} ${option.code}`);
                                    setDropdownOpen(false);
                                }}
                                className="px-3 py-2 text-sm hover:bg-purple-50 cursor-pointer flex items-center gap-2"
                            >
                                <span>{option.flag}</span> <span>{option.country}</span> <span>{option.code}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <input
                type="tel"
                placeholder="900 12 345"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className="flex-1 border focus:border-purple-600 focus:ring-purple-600 rounded-full px-4 py-2"
            />
        </div>
    )
}